import { generateInitialState } from "@/utils/redux/generateInitialState";
import { ProductState } from "./type";
import { generateInitialStateWithFilter } from "@/utils/redux/generateInitialStateWithFilter";
import { parseJson } from "@/utils/safeParse/parseJson";

export const productInitialState: ProductState = {
  product_list: generateInitialStateWithFilter({
    data: []
  }),
  get_items_price: generateInitialState({
    data: []
  }),
  design_detail: generateInitialState({
    data: {} as any
  }),
  product_seo: generateInitialState({
    data: {} as any
  }),
  create_order: generateInitialState({
    data: typeof localStorage !== "undefined" ? parseJson(localStorage.getItem("order")) || {} : {}
  }),
  check_coupon: generateInitialState({
    data: {} as any
  }),
  create_payment: generateInitialState({
    data: {} as any
  }),
  category_detail: generateInitialState({
    data: {} as any
  }),
  shipping_cost: generateInitialState({
    data: [] as any
  }),
  product_no_design: generateInitialState({
    data: {} as any
  }),
  productDetailState: {
    selectedVariantId: null,
    selectedAspectLabel: null
  },
  cartItems: typeof window !== 'undefined' ? parseJson(localStorage.getItem('items')) || [] : [],
  quantity: 1,
  countries: [],
  statesUs: [],
  state: {
    selectedVariantId: undefined
  }
}